<template>
  <div>
    <div>
      <v-checkbox
        v-model="actions.rf_settings_permanent_display"
        label="Always visible (does not dismiss)"
        trueValue="true"
        falseValue="false"
        class="promotion-closeBtn-checkbox"
      />
      <v-checkbox
        v-if="!isSticky"
        v-model="actions.rf_settings_close_button_enabled"
        label="Allow close"
        class="promotion-closeBtn-checkbox"
        trueValue="true"
        falseValue="false"
      />
    </div>
    <div v-if="actions.rf_settings_close_button_enabled === 'true'">
      <div v-if="!isSticky" style="padding-bottom: 20px">
        <RfPromoInteractionInterval
          interactionType="dismiss"
          :action="actions.rf_settings_dismiss_interval"
          @setIntervalAction="setIntervalAction"
        />
      </div>
      <RfRetentionActionsBehavior v-if="!isSticky" :model="model" :actions="actions" displayOff />
    </div>
    <span class="gray-text inline-block pt-2">{{ stickyHelpText }}</span>
  </div>
</template>

<script>
import RfPromoInteractionInterval from "@/components/RfPromotions/RfPromoInteractionInterval.vue";
import RfRetentionActionsBehavior from "@/components/RfPathCreate/RfRetentionActions/RfRetentionActionsBehavior.vue";

export default {
  name: "RfTileContainerOptions",
  components: {
    RfPromoInteractionInterval,
    RfRetentionActionsBehavior,
  },
  props: ["model", "actions"],
  computed: {
    isSticky() {
      return `${this.actions.rf_settings_permanent_display}` === "true";
    },
    stickyHelpText() {
      if (this.isSticky) {
        return "Only primary action is possible.";
      }
      return "Only primary, dismiss, and timeout actions are possible.";
    },
  },
  methods: {
    setIntervalAction(value, type) {
      this.actions[`rf_settings_${type}_interval`] = value;
    },
  },
};
</script>
